module.exports = __webpack_public_path__ + "img/monitora-icone.f8e22145.svg";